import { UNIVERSES, countryCode } from "./data/constants";
import { resolveDefaultPoiTypes } from "./data/options";
import MainView from "./desktop/mainView";
import { default as MobileMainView } from "./mobile/mainView";
import SERVICE_REGISTRY from "./services/registry";
import { SETTINGS } from "./settings";
import { EventManager } from "./utils/global";

/* eslint-disable no-new */
function getPageUrlParameters() {
    const parameters = {};
    const rawParameters = window.location.search.substring(1).replace(/&amp;/g, "&").split("&");

    for (const paramAndValue of rawParameters) {
        const [name, ...val] = paramAndValue.split("=");
        const key = decodeURIComponent(name);
        const value = decodeURIComponent(val.join("="));
        if (key !== "" && value !== "") parameters[key] = value;
    }

    return parameters;
}

class Map2 {
    constructor(container, mapOptions) {
        this.container = document.getElementById(`${container}`);
        this.options = mapOptions || {};
        // New. Call backend config with options from here...
        this.fetchConfig();
    }
    async fetchConfig() {
        const configParams = {
            country: this.options.country,
            business: this.options.business,
        };
        const { country, business = "all" } = configParams;
        const response = await total.maps.loadConfig(country, business);
        if (response) {
            SETTINGS.iconUrls = response.data.translations.icon;
            this.initialize();
        }
    }

    // eslint-disable-next-line
    addListener(event, func) {
        EventManager.add(event, func);
    }

    initialize() {
        let business;
        let brands;
        let country;
        let storeId;
        let autocompleteByName;
        let categories;

        // TODO: Remove this code after clarification
        // this.options.universe =
        //     typeof this.options.universe === "string" ? this.options.universe.toLowerCase().split(",") : [];
        this.options.poiTypes =
            typeof this.options.poiTypes === "string" ? this.options.poiTypes.toUpperCase().split(",") : [];
        this.options.brands =
            typeof this.options.brands === "string" ? this.options.brands.toUpperCase().split(",") : [];
        // TODO: Remove this code after clarification
        // this.options.segmentations =
        //     typeof this.options.segmentations === "string" ? this.options.segmentations.toLowerCase().split(",") : [];
        this.options.filters =
            typeof this.options.filters === "string" ? this.options.filters.toLowerCase().split(",") : [];
        // TODO: Remove this code after clarification
        // this.options.business = typeof this.options.business === "string" ? this.options.business.toLowerCase() : null;
        this.options.categories =
            typeof this.options.categories === "string" ? this.options.categories.toUpperCase().split(",") : [];

        if (typeof this.options.itinerary === "boolean") {
            SETTINGS.itinerary = this.options.itinerary;
        } else if (typeof this.options.itinerary === "string") {
            SETTINGS.itinerary = this.options.itinerary === "true";
        } else {
            SETTINGS.itinerary = true;
        }
        this.options.autocompleteByName =
            typeof this.options.autocompleteByName === "boolean" ? this.options.autocompleteByName : true;

        country = typeof this.options.country === "string" ? this.options.country.toLowerCase() : null;
        SETTINGS.country = country;
        const language = typeof this.options.language === "string" ? this.options.language.toLowerCase() : "";
        SETTINGS.googleDirectionsRequestOptions.language = language;
        this.options.status =
            typeof this.options.status === "string" ? this.options.status.toUpperCase().split(",") : [];
        this.options.favorites =
            typeof this.options.favorites === "string" ? this.options.favorites.toLowerCase().split(",") : [];

        if (typeof this.options.enableScrollwheel === "boolean") {
            SETTINGS.enableScrollWheel = this.options.enableScrollwheel;
        } else if (typeof this.options.enableScrollwheel === "string") {
            SETTINGS.enableScrollWheel = this.options.enableScrollwheel === "true";
        } else {
            SETTINGS.enableScrollWheel = true;
        }
        SETTINGS.rendererBreakScale =
            typeof this.options.rendererBreakScale === "number" && !Number.isNaN(this.options.rendererBreakScale)
                ? this.options.rendererBreakScale
                : SETTINGS.rendererBreakScale;
        SETTINGS.simpleRendererPointSize =
            typeof this.options.simpleRendererPointSize === "number" &&
            !Number.isNaN(this.options.simpleRendererPointSize)
                ? this.options.simpleRendererPointSize
                : SETTINGS.simpleRendererPointSize;
        SETTINGS.simpleRendererMinPointSize =
            typeof this.options.simpleRendererMinPointSize === "number" &&
            !Number.isNaN(this.options.simpleRendererMinPointSize)
                ? this.options.simpleRendererMinPointSize
                : SETTINGS.simpleRendererMinPointSize;

        SETTINGS.showPrices = !!this.options.showPrices;
        SETTINGS.displaySearch = !(this.options.displaySearch === false || this.options.displaySearch === "false");
        SETTINGS.specificTranslation = this.options.specificTranslation;
        SETTINGS.quadran = this.options.minifiche && this.options.minifiche === "quadran";

        // property to initialize map with search query
        const urlParameters = getPageUrlParameters();
        let mapSearchQuery;

        if (urlParameters.mapSearchQuery) {
            mapSearchQuery = urlParameters.mapSearchQuery;
        }

        // brands
        brands = [];
        if (this.options.brands.length !== 0) {
            for (const brand of this.options.brands) {
                // brands.push(brand);
                if (total.maps.parameters.brand.indexOf(brand) !== -1) {
                    brands.push(brand);
                } else {
                    console.warn(`TOTALMS: ${brand}`, "is not a valid brand code");
                }
            }
        } else {
            brands = ["TOTAL"];
        }

        // segmentations
        // TODO: Remove this code after clarification
        /*
            const segmentations = [];

            if (this.options.segmentations.length !== 0) {
                for (const segmentation of this.options.segmentations) {
                    if (total.maps.parameters.subbrand[segmentation]) {
                        segmentations.push(segmentation);
                        if (brands.indexOf(total.maps.parameters.subbrand[segmentation].brand) !== -1) {
                            const idx = brands.indexOf(total.maps.parameters.subbrand[segmentation].brand);
                            brands.splice(idx, 1);
                        }
                    } else {
                        console.warn(`TOTALMS: ${segmentation}`, "is not a valid segmentation code");
                    }
                }
            }
            */
        // filters
        const filters = [];
        if (this.options.filters.length !== 0) {
            for (const [key, value] of Object.entries(total.maps.L10n.products)) {
                if (this.options.filters.includes(key.toLowerCase())) {
                    filters.push(key);
                }
            }
            //CAR_WASH FILTERS TO BE TREATED DIFFERENTLY
            for (const [key, value] of Object.entries(
                total.maps.parameters.categories?.CAR_WASH?.sub_categories ?? {},
            )) {
                if (this.options.filters.includes(value.toLowerCase())) {
                    filters.push(value);
                }
            }
            //MEANS OF PAYMENT FILTERS TO BE TREATED DIFFERENTLY
            for (const filter of this.options.filters) {
                const matched = (total.maps.parameters.means_of_payments ?? []).find(
                    (mop) => mop.toLowerCase() === filter,
                );

                if (matched) {
                    filters.push(matched);
                }
            }
            //OFFERS OR MKT EVENTS FILTERS TO BE TREATED DIFFERENTLY
            for (const filter of this.options.filters) {
                const matched = (total.maps.parameters.offers ?? []).find((offer) => offer.toLowerCase() === filter);

                if (matched) {
                    filters.push(matched);
                }
            }
            //BRANDS
            for (const filter of this.options.filters) {
                const matched = total.maps.parameters.brand.find((brand) => brand.toLowerCase() === filter);

                if (matched) {
                    filters.push(matched);
                }
            }
        }

        // business
        // TODO: Remove this code after clarification
        /*
            if (this.options.business && total.maps.parameters.business[this.options.business.toString()]) {
                business = this.options.business.toString();
            } else if (this.options.business) {
                console.warn(`TOTALMS: ${this.options.business}`, "is not a valid business code");
            }
            
            // universe
            const universe = [];
            if (business) {
                for (const univers of total.maps.parameters.business[business].universe) {
                    if (total.maps.parameters.universe[univers]) {
                        universe.push({
                            code: univers,
                            filters: total.maps.parameters.universe[univers].item,
                            worldwide: total.maps.parameters.universe[univers].worldwide,
                            country: total.maps.parameters.universe[univers].country,
                        });
                    } else {
                        console.warn(`TOTALMS: ${univers}`, "is not a valid universe code");
                    }
                }
            }

            if (this.options.universe.length !== 0) {
                for (const univers of this.options.universe) {
                    if (total.maps.parameters.universe[univers]) {
                        universe.push({
                            code: univers,
                            filters: total.maps.parameters.universe[univers].item,
                            worldwide: total.maps.parameters.universe[univers].worldwide,
                            country: total.maps.parameters.universe[univers].country,
                        });
                    } else if (UNIVERSES.BRAND === univers) {
                        let universeFilters;

                        if (brands.length === 0) universeFilters = ["tot"];
                        else universeFilters = brands;

                        universe.push({
                            code: univers,
                            filters: universeFilters,
                        });
                    } else {
                        console.warn(`TOTALMS: ${univers}`, "is not a valid universe code");
                    }
                }
            }
            */
        // POI types
        const poiTypes = [];

        if (Array.isArray(this.options.poiTypes)) {
            for (const type of this.options.poiTypes) {
                if (total.maps.parameters.type.indexOf(type) !== -1) {
                    poiTypes.push(type);
                } else {
                    console.warn(`TOTALMS: ${type}`, "is not a valid POI type code");
                }
            }
        }

        // No poiTypes passed: default by business so the status × poiTypes × brands
        // query is still narrowed
        if (poiTypes.length === 0) {
            poiTypes.push(...resolveDefaultPoiTypes(this.options.business, total.maps.parameters.type));
        }

        //Manage Favorites
        const favorites = [];

        if (this.options.favorites.length !== 0) {
            for (const [key, value] of Object.entries(total.maps.L10n.products)) {
                if (this.options.favorites.includes(key.toLowerCase())) {
                    favorites.push(key);
                }
            }
            //CAR_WASH favorites TO BE TREATED DIFFERENTLY
            for (const [key, value] of Object.entries(
                total.maps.parameters.categories?.CAR_WASH?.sub_categories ?? {},
            )) {
                if (this.options.favorites.includes(value.toLowerCase())) {
                    favorites.push(value);
                }
            }
            //MEANS OF PAYMENT favorites TO BE TREATED DIFFERENTLY
            for (const filter of this.options.favorites) {
                const matched = (total.maps.parameters.means_of_payments ?? []).find(
                    (mop) => mop.toLowerCase() === filter,
                );

                if (matched) {
                    favorites.push(matched);
                }
            }
            //OFFERS OR MKT EVENTS favorites TO BE TREATED DIFFERENTLY
            for (const filter of this.options.favorites) {
                const matched = (total.maps.parameters.offers ?? []).find((offer) => offer.toLowerCase() === filter);

                if (matched) {
                    favorites.push(matched);
                }
            }
            //BRANDS
            for (const filter of this.options.favorites) {
                const matched = total.maps.parameters.brand.find((brand) => brand.toLowerCase() === filter);

                if (matched) {
                    favorites.push(matched);
                }
            }
        }
        const pageUrl = decodeURIComponent(window.location.search.substring(1));
        const urlVariables = pageUrl.split("&");

        for (const paramAndValue of urlVariables) {
            const [name, value] = paramAndValue.split("=");
            if (name === "storeId") {
                storeId = value;
            }
        }
        //NEW: Categories
        categories = [];
        if (this.options.categories.length > 0 && Array.isArray(this.options.categories)) {
            for (const category of this.options.categories) {
                for (const [key, value] of Object.entries(total.maps.parameters.categories)) {
                    if (category === key) {
                        categories.push({
                            code: key,
                            subcategories: value.sub_categories,
                            products: value.products,
                        });
                    }
                }
            }
        } else if (total.maps.parameters.categories) {
            for (const [key, value] of Object.entries(total.maps.parameters.categories)) {
                if (value.products && value.products.length > 0) {
                    categories.push({
                        code: key,
                        subcategories: value.sub_categories,
                        products: value.products,
                    });
                }
            }
        }

        // status
        const status = [];

        const statusTemp = String(this.options.status) ? String(this.options.status).split(",") : [];

        // Initial (01),Open (02),Temporary Closed (03),Permanently Closed (04))
        for (const currentStatus of statusTemp) {
            status.push(currentStatus);
        }

        // mandatory value if no status is passed or all values are not valid (number between 1 and 7 included)
        if (status.length === 0) status.push("OPEN");

        // miles / km unit
        if (country && ["us", "gb", "mm", "lr"].indexOf(country) !== -1) {
            SETTINGS.unitSystem = google.maps.UnitSystem.IMPERIAL;
        } else {
            SETTINGS.unitSystem = google.maps.UnitSystem.METRIC;
        }

        // Aviation portal: these users navigate by IATA/ICAO codes and have no road routing.
        // Detect via the business option (aviation preset uses business: 'aviation');
        // fall back to AIRPORT/AIRFIELD poiTypes if the business code is absent.
        const businessOption = typeof this.options.business === "string" ? this.options.business.toLowerCase() : "";
        SETTINGS.isAviationPortal =
            businessOption === "aviation" || poiTypes.indexOf("AIRPORT") > -1 || poiTypes.indexOf("AIRFIELD") > -1;
        if (SETTINGS.isAviationPortal) {
            SETTINGS.itinerary = false;
        }
        // options.autocompleteByName
        if (this.options.autocompleteByName) {
            // if (!SETTINGS.isAviationPortal) {
            //     throw new Error("autocompleteByName must be used only with the T001 type and the B001 business");
            // }
            autocompleteByName = this.options.autocompleteByName;
        }

        SETTINGS.country = country;
        const validateOptions = () => {
            if (!this.container) throw new Error("The container does not exist.");
            if (country && !(country.toUpperCase() in countryCode)) country = null;
            if (SETTINGS.rendererBreakScale < 0 || SETTINGS.rendererBreakScale > 21) SETTINGS.rendererBreakScale = 12;
            if (SETTINGS.simpleRendererPointSize < 1 || SETTINGS.simpleRendererPointSize > 16)
                SETTINGS.simpleRendererPointSize = 10;
            if (SETTINGS.simpleRendererMinPointSize < 1 || SETTINGS.simpleRendererMinPointSize > 16)
                SETTINGS.simpleRendererMinPointSize = 4;
        };
        validateOptions();

        // Initialize services
        SERVICE_REGISTRY.filterService.init(country, brands, filters, status, poiTypes, categories, favorites);
        SERVICE_REGISTRY.storeService.init(brands, status);

        // TO DO !!! IMPORTANT ENFORCE device parameter to desktop !!!
        total.maps.device = "desktop";

        if (total.maps.device === "mobile") {
            new MobileMainView(
                this.container,
                brands,
                country,
                filters,
                language,
                mapSearchQuery,
                autocompleteByName,
                business,
            );
        } else if (total.maps.device === "desktop-detail") {
            if (!storeId) {
                throw new Error("storeId must be defined for detail map.");
            }
            new MainView(this.container, brands, country, filters, language, null, storeId, null);
        } else if (total.maps.device === "mobile-detail") {
            if (!storeId) {
                throw new Error("storeId must be defined for detail map.");
            }
            new MainView(this.container, brands, country, filters, language, null, storeId, true);
        } else {
            new MainView(
                this.container,
                brands,
                country,
                filters,
                language,
                mapSearchQuery,
                null,
                null,
                autocompleteByName,
                business,
            );
        }
    }
}

window.total.maps.Map = Map2;
